import { SvgIcon } from '@mui/material';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const IconJadesoft = ({ height, width }) => (
  <SvgIcon
    focusable="false"
    viewBox="0 0 281 43"
    aria-hidden="true"
    width="281"
    height="43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: !isNil(width) ? `${width}px` : 'inherit', // TODO: get the width
      height: !isNil(height) ? `${height}px` : 'inherit',
    }}
  >
    <svg width="281" height="43" viewBox="0 0 281 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_462_600)">
        <path
          d="M51.9892 1.11984C52.5714 1.61909 52.022 2.45865 51.7041 2.94235C47.7568 8.92986 43.0235 14.4769 37.4782 20.5024C37.435 20.5507 37.3987 20.6043 37.3521 20.6492C36.0219 21.9224 36.2551 22.1901 34.3946 22.1763C26.9439 22.1262 19.146 22.1262 11.4051 22.1677C11.2772 22.1677 11.1529 22.1608 11.0319 22.121C10.5275 21.9587 10.2097 21.4369 10.3358 20.9222C10.4049 20.6406 10.5448 20.3694 10.7175 20.0981C11.4915 18.882 15.9398 13.487 16.9728 12.5662C17.4928 12.1033 18.0663 11.8424 18.7659 11.7578C22.5302 11.3086 24.4356 12.0204 28.4123 11.8113C29.2 11.7699 29.9342 11.4054 30.4507 10.8094L39.3629 1.74692C39.8138 1.22695 40.4581 0.914269 41.1457 0.883174C43.4294 0.777797 47.6065 0.653417 50.0751 0.703515C50.8974 0.720789 51.7612 0.924634 51.9892 1.11984Z"
          fill="url(#paint0_linear_462_600)"
        />
        <path
          d="M50.4411 0.782981C51.1718 1.2494 50.2821 2.36882 49.9816 2.82316C46.264 8.46171 42.5931 13.0655 37.3691 18.7421C37.3276 18.787 37.2931 18.8371 37.2499 18.8802C35.9957 20.0809 35.5794 20.9532 33.826 20.9412C26.8072 20.8928 19.4619 20.8928 12.1701 20.9325C12.0509 20.9325 11.9317 20.9256 11.8177 20.8893C11.3426 20.7356 11.0438 20.245 11.163 19.7613C11.2286 19.4952 11.3599 19.2396 11.5223 18.9839C12.2513 17.8386 16.4422 12.7563 17.4148 11.8891C17.9054 11.452 18.4461 11.2067 19.1043 11.1272C22.6508 10.704 24.2954 11.3743 28.0406 11.1773C28.7817 11.1376 30.2794 10.837 30.7666 10.2756L38.3572 1.69683C38.7822 1.20794 39.3885 0.912543 40.0364 0.883175C42.904 0.750158 49.9366 0.461666 50.4411 0.782981Z"
          fill="url(#paint1_linear_462_600)"
        />
        <path
          d="M87.5237 1.61909C88.0264 1.71928 88.6242 2.02505 88.6052 2.53639C88.6052 2.56749 88.6017 2.59513 88.5965 2.61931C88.5067 3.046 83.2465 9.82643 82.5658 10.5503C81.4948 11.6904 81.0508 12.3607 79.3855 12.5161C75.3656 12.8927 68.3692 11.6576 65.0265 13.0327C61.0429 14.6721 52.5454 27.1342 48.9418 31.0107C45.4954 34.718 40.9504 36.5577 35.7575 36.9412C24.6048 37.767 12.1288 36.8203 1.18857 36.9291C1.01928 36.9291 0.85344 36.9015 0.703147 36.822L0.499303 36.7132C0.0156033 36.4558 -0.145054 35.8443 0.146893 35.3796C0.38356 35.0013 0.99164 34.0546 1.31123 33.6573C1.7241 33.1442 1.85539 32.9144 2.06096 32.6588C2.77615 31.7622 5.88046 28.6389 7.07416 27.8874C7.22273 27.7941 7.39375 27.7475 7.56995 27.7475L34.9733 27.706C35.0061 27.706 35.0406 27.706 35.0752 27.7009C38.0862 27.4279 39.4872 26.1046 41.3909 24.0247C47.9191 16.8971 54.9397 2.50184 65.3427 1.57417C65.3789 1.57072 65.4135 1.56899 65.4498 1.56899C65.4498 1.56899 79.522 1.44116 85.8602 1.45325C86.2368 1.45325 87.1091 1.53617 87.5237 1.61909Z"
          fill="url(#paint2_linear_462_600)"
        />
        <path
          d="M85.8843 1.44288C86.3835 1.44288 86.8154 1.84539 86.7981 2.34464C86.7981 2.37573 86.7947 2.40165 86.7895 2.42583C86.7031 2.84216 82.1287 8.34597 81.4671 9.04906C80.4237 10.1598 79.9918 10.8111 78.3697 10.9631C74.4552 11.3311 67.0908 10.127 63.8345 11.4658C59.9545 13.062 51.6781 25.1994 48.1696 28.9757C44.813 32.5862 40.9365 34.927 35.8784 35.3018C25.028 36.1051 12.2117 35.1567 2.24921 35.288C2.06091 35.2898 1.87434 35.25 1.71541 35.1481L1.5323 35.0324C1.11597 34.7663 0.979501 34.2187 1.23344 33.7955C1.78797 32.8713 2.91948 31.586 3.28917 31.123C3.8506 30.4199 5.79922 27.9859 7.12421 26.6644C7.67874 26.1098 8.42674 25.7989 9.21103 25.7972L35.1114 25.7574C35.1442 25.7574 35.1788 25.7574 35.2116 25.7522C38.1432 25.4862 39.5079 24.1975 41.3632 22.1729C47.7256 15.2283 54.563 2.30318 64.6965 1.40488C64.7294 1.40142 64.7639 1.40142 64.7967 1.40142L85.886 1.44288H85.8843Z"
          fill="url(#paint3_linear_462_600)"
        />
        <path
          d="M227.194 3.80783C228.911 3.65235 231.462 3.63853 233.185 3.756C240.786 4.27425 240.233 9.67441 239.566 15.8105C238.986 21.145 238.115 27.4124 237.101 32.6657C235.31 41.951 231.54 42.8631 222.628 42.1911C215.652 41.6659 215.696 37.3317 216.221 31.3562C216.701 25.8766 217.656 19.1307 218.679 13.7254C219.721 8.21295 221.021 4.36408 227.194 3.80783ZM231.252 10.4172C230.638 9.88517 228.907 9.99573 228.225 10.3931C227.52 10.8025 227.152 12.181 226.967 12.9549C225.402 19.5229 225.167 27.383 224.226 34.1064C224.374 35.174 224.604 35.5541 225.68 35.6974C228.092 36.017 228.489 34.711 228.959 32.664C230.454 26.1565 230.747 18.6298 231.744 11.9893C231.649 11.5401 231.601 10.7213 231.252 10.4172Z"
          fill="url(#paint4_linear_462_600)"
        />
        <path
          d="M214.26 14.983H207.326C207.516 12.2467 208.837 9.18898 204.724 9.94563C203.425 10.184 203.169 11.8165 202.976 12.9273C202.762 14.1504 202.464 16.0748 202.972 17.1942C203.722 18.8474 207.084 19.4348 208.68 20.1361C214.401 22.6548 213.608 26.8233 212.731 32.2494C212.185 35.6197 211.494 39.9505 208.011 41.4258C205.332 42.5608 197.242 42.6264 194.713 41.1442C191.343 39.168 193.088 33.2496 193.309 30.0468H200.393C200.604 31.5756 198.857 35.44 201.107 35.8529C204.549 36.4835 204.885 34.8561 205.348 31.9488C205.614 30.2748 206.123 28.1483 204.689 26.9736C202.171 24.9127 198.132 25.4603 196.109 21.8878C194.262 18.6246 195.544 8.92813 198.054 6.06567C200.409 3.37941 205.771 3.51588 209.058 3.76291C216.293 4.3088 214.992 9.37901 214.261 14.983H214.26Z"
          fill="url(#paint5_linear_462_600)"
        />
        <path
          d="M260.842 4.06868L259.937 10.6798L252.398 10.6781L251.042 21.2867H257.525L256.772 27.5903L250.138 27.5886L248.178 41.8853H240.188L245.54 4.06868H260.842Z"
          fill="url(#paint6_linear_462_600)"
        />
        <path
          d="M280.891 4.06868L279.996 10.6124L274.566 10.6885L270.338 41.8853H262.198L266.57 10.6798H261.142L262.122 4.06868H280.891Z"
          fill="url(#paint7_linear_462_600)"
        />
        <path
          d="M137.694 41.2997L142.885 3.62644C142.989 3.46924 143.18 3.49515 143.339 3.47615C145.848 3.16174 150.645 3.36213 153.304 3.47615C155.582 3.57462 159.241 3.81647 160.908 5.55951C163.397 8.16458 162.35 14.3577 161.943 17.6796C161.374 22.3042 160.69 27.5557 159.809 32.106C158.495 38.8916 156.638 40.9577 149.684 41.3049C145.746 41.5018 141.648 41.146 137.694 41.298V41.2997ZM146.587 34.9978H148.924C149.194 34.9978 150.09 34.6575 150.362 34.4657C151.438 33.7056 151.759 31.5532 151.991 30.2852C152.856 25.5156 153.537 20.0601 154.103 15.2231C154.245 14.0087 154.81 11.1169 153.863 10.2428C153.001 9.44638 151.004 9.91453 149.902 9.7867L146.587 34.9978Z"
          fill="url(#paint8_linear_462_600)"
        />
        <path
          d="M134.98 41.2997H126.689L126.84 33.4603H120.885L118.624 41.2997H110.86L121.865 3.48306H134L134.98 41.2997ZM122.317 27.3122H126.764C127.211 26.4139 126.938 25.0595 126.983 24.0006C127.178 19.4469 127.368 14.584 127.14 10.0165C127.132 9.83161 127.253 9.34791 126.916 9.4792L122.317 27.3122Z"
          fill="url(#paint9_linear_462_600)"
        />
        <path
          d="M184.122 3.48306L183.196 9.76424C182.842 9.99227 176.994 9.63295 175.899 9.77806C175.643 9.81261 175.441 9.83507 175.301 10.0907L174.172 18.8543H181.106L180.344 24.8418L173.273 24.8591L171.909 34.8423H180.199L179.294 41.298H163.014L168.289 3.48133H184.117L184.122 3.48306Z"
          fill="url(#paint10_linear_462_600)"
        />
        <path
          d="M114.63 3.48306L110.512 32.5655C109.586 41.0181 105.046 42.2308 97.5225 41.6038C89.7678 40.9594 92.9965 32.1837 93.3748 27.0029H100.159C99.8598 28.6873 99.4798 30.6048 99.4055 32.3081C99.3502 33.5899 99.1377 35.1792 100.822 35.1343C102.475 35.0911 102.349 33.0457 102.696 31.8209L106.64 3.48306H114.63Z"
          fill="url(#paint11_linear_462_600)"
        />
        <path
          d="M227.363 2.27208C229.079 2.12006 231.627 2.10624 233.347 2.22026C240.94 2.72641 240.389 8.0091 239.722 14.0122C239.143 19.2309 238.272 25.3618 237.26 30.5011C235.47 39.5843 231.706 40.4774 222.803 39.8193C215.834 39.3045 215.879 35.0669 216.402 29.2211C216.882 23.8624 217.838 17.2633 218.859 11.9737C219.9 6.58046 221.199 2.81624 227.365 2.27208H227.363ZM231.416 8.73811C230.804 8.2164 229.073 8.32696 228.393 8.71392C227.69 9.1147 227.322 10.4622 227.137 11.2188C225.573 17.6434 225.339 25.3325 224.399 31.909C224.547 32.9542 224.777 33.3256 225.852 33.4655C228.26 33.7782 228.657 32.5016 229.127 30.4994C230.62 24.1336 230.913 16.7727 231.908 10.2756C231.813 9.8368 231.765 9.03524 231.416 8.73811Z"
          fill="url(#paint12_linear_462_600)"
        />
        <path
          d="M214.445 13.2054H207.518C207.706 10.5278 209.028 7.5375 204.918 8.27859C203.619 8.51181 203.365 10.108 203.171 11.1963C202.957 12.3935 202.662 14.2765 203.168 15.37C203.916 16.9869 207.276 17.5622 208.869 18.248C214.583 20.7114 213.792 24.79 212.914 30.0986C212.37 33.3947 211.679 37.6322 208.2 39.0747C205.524 40.1855 197.443 40.2494 194.917 38.7983C191.552 36.8652 193.293 31.0764 193.515 27.9427H200.592C200.803 29.4387 199.058 33.2185 201.306 33.621C204.743 34.2377 205.078 32.6467 205.541 29.8015C205.807 28.1638 206.315 26.0839 204.883 24.9351C202.368 22.9191 198.333 23.4547 196.313 19.9599C194.468 16.7675 195.75 7.28183 198.257 4.48155C200.609 1.85403 205.965 1.98705 209.249 2.2289C216.475 2.76269 215.176 7.72234 214.445 13.2037V13.2054Z"
          fill="url(#paint13_linear_462_600)"
        />
        <path
          d="M260.974 2.52775L260.07 8.9955L252.54 8.99378L251.186 19.3709H257.66L256.909 25.5363L250.282 25.5346L248.325 39.5204H240.344L245.69 2.52775H260.974Z"
          fill="url(#paint14_linear_462_600)"
        />
        <path
          d="M281 2.52775L280.107 8.92986L274.683 9.00241L270.459 39.5204H262.328L266.695 8.99378H261.274L262.253 2.52775H281Z"
          fill="url(#paint15_linear_462_600)"
        />
        <path
          d="M137.965 38.9469L143.151 2.09588C143.254 1.94213 143.444 1.96804 143.605 1.94904C146.11 1.64155 150.902 1.83675 153.557 1.94904C155.834 2.04578 159.488 2.28245 161.153 3.98749C163.639 6.53555 162.594 12.5939 162.188 15.8433C161.621 20.3676 160.937 25.5052 160.058 29.9552C158.745 36.5923 156.89 38.6135 149.945 38.952C146.012 39.1438 141.917 38.7966 137.968 38.9451L137.965 38.9469ZM146.849 32.7831H149.183C149.453 32.7831 150.348 32.4497 150.619 32.2632C151.695 31.5203 152.015 29.4145 152.246 28.1742C153.112 23.5082 153.79 18.172 154.357 13.4404C154.499 12.2536 155.064 9.42393 154.117 8.56709C153.257 7.78798 151.261 8.24577 150.161 8.12139L146.849 32.7831Z"
          fill="url(#paint16_linear_462_600)"
        />
        <path
          d="M135.254 38.9486H126.973L127.123 31.2802H121.175L118.917 38.9486H111.163L122.155 1.95595H134.277L135.256 38.9486H135.254ZM122.607 25.2634H127.049C127.494 24.3858 127.223 23.0591 127.268 22.0243C127.463 17.5708 127.653 12.8115 127.425 8.34424C127.417 8.16285 127.538 7.68952 127.201 7.81908L122.607 25.2634Z"
          fill="url(#paint17_linear_462_600)"
        />
        <path
          d="M184.341 1.95595L183.417 8.10066C183.065 8.32351 177.222 7.97283 176.129 8.11448C175.873 8.14731 175.671 8.17149 175.533 8.42025L174.405 16.9921H181.33L180.57 22.8483L173.508 22.8639L172.145 32.6294H180.427L179.523 38.9451H163.261L168.531 1.9525H184.341V1.95595Z"
          fill="url(#paint18_linear_462_600)"
        />
        <path
          d="M114.927 1.95595L110.814 30.4044C109.888 38.6739 105.355 39.859 97.8384 39.2457C90.0923 38.6152 93.3176 30.0312 93.6959 24.9628H100.471C100.172 26.6091 99.794 28.4869 99.7197 30.1522C99.6644 31.4063 99.4536 32.9611 101.134 32.9179C102.786 32.8764 102.66 30.8743 103.007 29.6754L106.946 1.95423H114.927V1.95595Z"
          fill="url(#paint19_linear_462_600)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_462_600"
          x1="16.9642"
          y1="20.7943"
          x2="49.5569"
          y2="6.51136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00807C" />
          <stop offset="0.09" stop-color="#008877" />
          <stop offset="0.25" stop-color="#00A06B" />
          <stop offset="0.36" stop-color="#00B661" />
          <stop offset="0.57" stop-color="#008B78" />
          <stop offset="0.72" stop-color="#007780" />
          <stop offset="0.87" stop-color="#00A969" />
          <stop offset="1" stop-color="#007982" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_462_600"
          x1="25.572"
          y1="-1.64934"
          x2="38.8306"
          y2="28.8082"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.43" stop-color="#007780" />
          <stop offset="0.49" stop-color="#00827A" />
          <stop offset="0.59" stop-color="#00A16B" />
          <stop offset="0.65" stop-color="#00B661" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_462_600"
          x1="-1.74472"
          y1="12.2933"
          x2="85.2953"
          y2="25.4862"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.06" stop-color="#939598" />
          <stop offset="0.17" stop-color="#666769" />
          <stop offset="0.2" stop-color="#575759" />
          <stop offset="0.25" stop-color="#59595B" />
          <stop offset="0.27" stop-color="#616163" />
          <stop offset="0.29" stop-color="#6E6F71" />
          <stop offset="0.31" stop-color="#818385" />
          <stop offset="0.32" stop-color="#9A9C9E" />
          <stop offset="0.36" stop-color="#9D9FA1" />
          <stop offset="0.39" stop-color="#A8AAAC" />
          <stop offset="0.43" stop-color="#BBBCBD" />
          <stop offset="0.46" stop-color="#D5D6D6" />
          <stop offset="0.49" stop-color="#F7F7F7" />
          <stop offset="0.53" stop-color="#DADBDC" />
          <stop offset="0.57" stop-color="#C7C8CA" />
          <stop offset="0.6" stop-color="#C1C2C4" />
          <stop offset="0.61" stop-color="#B7B8BA" />
          <stop offset="0.64" stop-color="#9F9FA2" />
          <stop offset="0.68" stop-color="#8D8D90" />
          <stop offset="0.71" stop-color="#838386" />
          <stop offset="0.75" stop-color="#808083" />
          <stop offset="0.82" stop-color="#A8A9AB" />
          <stop offset="0.85" stop-color="#C0C1C3" />
          <stop offset="0.94" stop-color="#D5D6D7" />
          <stop offset="1" stop-color="#272728" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_462_600"
          x1="7.46626"
          y1="37.304"
          x2="86.6375"
          y2="2.57267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.15" stop-color="#C4C5C7" />
          <stop offset="0.2" stop-color="#D0D1D3" />
          <stop offset="0.32" stop-color="#D2D3D5" />
          <stop offset="0.39" stop-color="#DADBDC" />
          <stop offset="0.44" stop-color="#E8E8E9" />
          <stop offset="0.49" stop-color="#FBFBFB" />
          <stop offset="0.57" stop-color="#E9E9EA" />
          <stop offset="0.66" stop-color="#DFDFE0" />
          <stop offset="0.76" stop-color="#DCDCDD" />
          <stop offset="0.91" stop-color="#B2B4B6" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_462_600"
          x1="216.013"
          y1="23.0211"
          x2="239.924"
          y2="23.0211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_462_600"
          x1="192.657"
          y1="22.9554"
          x2="214.847"
          y2="22.9554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_462_600"
          x1="240.188"
          y1="22.9779"
          x2="260.842"
          y2="22.9779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_462_600"
          x1="261.142"
          y1="22.9779"
          x2="280.891"
          y2="22.9779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_462_600"
          x1="137.694"
          y1="22.337"
          x2="162.511"
          y2="22.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_462_600"
          x1="110.86"
          y1="22.3923"
          x2="134.98"
          y2="22.3923"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_462_600"
          x1="163.019"
          y1="22.3923"
          x2="184.122"
          y2="22.3923"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_462_600"
          x1="92.3884"
          y1="22.6151"
          x2="114.63"
          y2="22.6151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A5A7AA" />
          <stop offset="0.07" stop-color="#86888A" />
          <stop offset="0.2" stop-color="#3F3F3F" />
          <stop offset="0.28" stop-color="#414141" />
          <stop offset="0.32" stop-color="#494949" />
          <stop offset="0.36" stop-color="#575757" />
          <stop offset="0.39" stop-color="#6B6B6B" />
          <stop offset="0.41" stop-color="#858585" />
          <stop offset="0.44" stop-color="#A4A4A4" />
          <stop offset="0.46" stop-color="#CACACA" />
          <stop offset="0.49" stop-color="#FCFCFC" />
          <stop offset="0.5" stop-color="#F1F1F1" />
          <stop offset="0.54" stop-color="#CACACA" />
          <stop offset="0.58" stop-color="#AAAAAA" />
          <stop offset="0.62" stop-color="#919191" />
          <stop offset="0.66" stop-color="#7F7F7F" />
          <stop offset="0.71" stop-color="#757575" />
          <stop offset="0.76" stop-color="#727272" />
          <stop offset="0.98" stop-color="#96989B" />
          <stop offset="1" stop-color="#9A9C9F" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_462_600"
          x1="226.171"
          y1="51.8288"
          x2="229.334"
          y2="2.27381"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_462_600"
          x1="202.074"
          y1="50.2913"
          x2="205.237"
          y2="0.736337"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_462_600"
          x1="248.601"
          y1="53.2609"
          x2="251.764"
          y2="3.70591"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_462_600"
          x1="268.027"
          y1="54.5013"
          x2="271.19"
          y2="4.94625"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_462_600"
          x1="148.94"
          y1="46.9003"
          x2="152.103"
          y2="-2.65647"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_462_600"
          x1="122.808"
          y1="45.2315"
          x2="125.971"
          y2="-4.3235"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_462_600"
          x1="172.019"
          y1="48.3738"
          x2="175.182"
          y2="-1.18291"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_462_600"
          x1="102.124"
          y1="43.9117"
          x2="105.287"
          y2="-5.64331"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stop-color="#727272" />
          <stop offset="0.42" stop-color="#969696" />
          <stop offset="0.7" stop-color="#F2F2F2" />
        </linearGradient>
        <clipPath id="clip0_462_600">
          <rect width="281" height="41.7277" fill="white" transform="translate(0 0.636143)" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

IconJadesoft.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconJadesoft;
